"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteSC = exports.revokeSC = exports.SCSchema = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var currenciesList_1 = require("common/global/currenciesList");
var firebase_1 = __importDefault(require("firebase"));
var formik_1 = require("formik");
var htmlToImage = __importStar(require("html-to-image"));
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var Yup = __importStar(require("yup"));
var useTitle_1 = __importDefault(require("../../../hooks/useTitle"));
var generateAndUploadWord_1 = require("./generateAndUploadWord");
var getWordFileUrlBySCId_1 = require("./getWordFileUrlBySCId");
var htmlToImg_1 = __importDefault(require("./htmlToImg"));
var react_router_dom_1 = require("react-router-dom");
exports.SCSchema = Yup.object().shape({
    contractNo: Yup.string().required(),
    consumerDetails: Yup.string().required(),
    agreedTerms: Yup.string().required(),
    specialProvisionsAndConditions: Yup.string().required(),
    notices: Yup.string().required(),
    contractValidUntil: Yup.date().required(),
    currencyId: Yup.string().required(),
    exchangeRate: Yup.string().required(),
});
var TextArea = antd_1.Input.TextArea;
function SCCreate() {
    var _this = this;
    var _a, _b;
    var t = (0, react_i18next_1.useTranslation)().t;
    var params = (0, react_router_dom_1.useParams)();
    var SCId = params.SCId;
    var _c = (0, firestore_1.useDocument)(collectionsRef_1.SCRef.doc(SCId)), SCSnapshot = _c[0], SCLoading = _c[1];
    var SCData = (_a = SCSnapshot === null || SCSnapshot === void 0 ? void 0 : SCSnapshot.data()) !== null && _a !== void 0 ? _a : {};
    (0, useTitle_1.default)(t("orders.SC"));
    var Option = antd_1.Select.Option;
    var tableRef = (0, react_1.useRef)();
    var formProps = (0, formik_1.useFormik)({
        validationSchema: exports.SCSchema,
        initialValues: {
            contractNo: "",
            consumerDetails: "",
            agreedTerms: "",
            deliveryTerms: "",
            specialProvisionsAndConditions: "",
            notices: "",
            supplierId: "",
            contractValidUntil: (0, moment_1.default)(),
            currencyId: "",
            exchangeRate: 0,
        },
        onSubmit: function (values, form) { return __awaiter(_this, void 0, void 0, function () {
            var templateData, SCData;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        templateData = {
                            CONTRACTNO: values.contractNo,
                            consumerDetails: values.consumerDetails,
                            agreedTerms: values.agreedTerms,
                            deliveryTerms: values.deliveryTerms,
                            specialProvisionsAndConditions: values.specialProvisionsAndConditions,
                            notices: values.notices,
                            exchangeRate: values.exchangeRate,
                            contractValidUntil: (_b = (_a = values.contractValidUntil) === null || _a === void 0 ? void 0 : _a.toDate().toLocaleDateString()) !== null && _b !== void 0 ? _b : null,
                            currencyId: values.currencyId,
                        };
                        return [4 /*yield*/, collectionsRef_1.SCRef.doc(SCId).update(__assign({}, templateData))];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, collectionsRef_1.SCRef.doc(SCId).get()];
                    case 2:
                        SCData = (_c.sent()).data();
                        return [4 /*yield*/, (0, generateAndUploadWord_1.generateAndUploadWord)(formServiceAgreementIDA, SCData, SCId).then(function () {
                                collectionsRef_1.SCRef.doc(SCId).update({ status: "approved" });
                                antd_1.message.success(t("alerts.success"));
                                form.resetForm();
                            })];
                    case 3:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var htmlToImg = function () {
        htmlToImage
            .toJpeg(tableRef.current, {
            quality: 1000,
            backgroundColor: "white",
            height: 750,
            width: 750,
            cacheBust: true,
        })
            .then(function (dataUrl) {
            var link = document.createElement("a");
            link.download = "SCItemsImg.png";
            link.href = dataUrl;
            link.click();
        })
            .catch(function (error) {
            console.error("oops, something went wrong!", error);
        });
    };
    var _d = (0, react_1.useState)(false), loaded = _d[0], setLoaded = _d[1];
    (0, react_1.useEffect)(function () {
        if (!SCSnapshot || loaded || !SCSnapshot.data()) {
            return;
        }
        setLoaded(true);
        var SC = SCSnapshot.data();
        formProps.setValues({
            supplierId: SC.supplierId,
            contractNo: SC.CONTRACTNO,
            consumerDetails: SC.consumerDetails,
            agreedTerms: SC.agreedTerms,
            // totalValueOfContract: SC.totalValueOfContract,
            deliveryTerms: SC.deliveryTerms,
            specialProvisionsAndConditions: SC.specialProvisionsAndConditions,
            notices: SC.notices,
            contractValidUntil: (0, moment_1.default)(SC.contractValidUntil),
            currencyId: SC.currencyId,
            exchangeRate: SC.exchangeRate,
        });
    }, [formProps, loaded, SCSnapshot]);
    var formItemLayout = {
        labelCol: {
            xs: { span: 26 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
        },
    };
    if (SCLoading) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.profileBox }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: index_modules_css_1.default.infoBox }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "primary", style: { marginLeft: 10, marginBottom: 10, marginRight: 12 }, onClick: formProps.submitForm, loading: formProps.isSubmitting }, { children: t("common.save") })), ((_b = SCSnapshot === null || SCSnapshot === void 0 ? void 0 : SCSnapshot.data()) === null || _b === void 0 ? void 0 : _b.status) === "approved" || "" || undefined ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "primary", style: { marginLeft: 10, marginBottom: 10, marginRight: 12 }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                var wordFileUrl, link;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, (0, getWordFileUrlBySCId_1.getWordFileUrlBySCId)(SCId)];
                                        case 1:
                                            wordFileUrl = _a.sent();
                                            link = document.createElement("a");
                                            link.download = "SCWordFile.docx";
                                            link.href = wordFileUrl;
                                            link.click();
                                            htmlToImg();
                                            antd_1.message.success(t("alerts.success"));
                                            return [2 /*return*/];
                                    }
                                });
                            }); } }, { children: t("sc.downloadSC") }))) : null, (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "primary", style: { marginBottom: 50 }, onClick: function () {
                                firebase_1.default.firestore().runTransaction(function (transaction) { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, (0, exports.revokeSC)(SCData.orderId, SCId, transaction)
                                                    .then(function () {
                                                    antd_1.message.success(t("alerts.success"));
                                                    history.back();
                                                })
                                                    .catch(function () {
                                                    antd_1.message.error(t("alerts.error"));
                                                })];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); });
                            } }, { children: t("orders.revoke") })), (0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({}, formItemLayout, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("contractNo").touched) &&
                                        formProps.errors.contractNo &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("contractNo").touched) &&
                                        formProps.errors.contractNo, label: t("sc.contractNo"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.contractNo, onChange: function (e) {
                                            return formProps.setFieldValue("contractNo", e.target.value);
                                        } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("consumerDetails").touched) &&
                                        formProps.errors.consumerDetails &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("consumerDetails").touched) &&
                                        formProps.errors.consumerDetails, label: t("sc.consumerDetails"), required: true }, { children: (0, jsx_runtime_1.jsx)(TextArea, { className: index_modules_css_1.default.formInputs, value: formProps.values.consumerDetails, onChange: function (e) {
                                            return formProps.setFieldValue("consumerDetails", e.target.value);
                                        } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("agreedTerms").touched) &&
                                        formProps.errors.agreedTerms &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("agreedTerms").touched) &&
                                        formProps.errors.agreedTerms, label: t("sc.agreedTerms"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.agreedTerms, onChange: function (e) {
                                            return formProps.setFieldValue("agreedTerms", e.target.value);
                                        } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("deliveryTerms").touched) &&
                                        formProps.errors.deliveryTerms &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("deliveryTerms").touched) &&
                                        formProps.errors.deliveryTerms, label: t("sc.deliveryTerms"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.deliveryTerms, onChange: function (e) {
                                            return formProps.setFieldValue("deliveryTerms", e.target.value);
                                        } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("specialProvisionsAndConditions")
                                            .touched) &&
                                        formProps.errors.specialProvisionsAndConditions &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("specialProvisionsAndConditions")
                                            .touched) &&
                                        formProps.errors.specialProvisionsAndConditions, label: t("sc.specialProvisionsAndConditions"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.specialProvisionsAndConditions, onChange: function (e) {
                                            return formProps.setFieldValue("specialProvisionsAndConditions", e.target.value);
                                        } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("currencyId").touched) &&
                                        formProps.errors.currencyId &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("currencyId").touched) &&
                                        formProps.errors.currencyId, label: t("common.currency"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ showSearch: true, optionFilterProp: "children", value: formProps.values.currencyId, onChange: function (e) { return formProps.setFieldValue("currencyId", e); } }, { children: (0, lodash_1.map)(currenciesList_1.globalCurrenciesData, function (value, key) {
                                            return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: value.name }, { children: value.name }), key));
                                        }) })) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("contractValidUntil").touched) &&
                                        formProps.errors.notices &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("contractValidUntil").touched) &&
                                        formProps.errors.notices, label: t("sc.contractValidUntil"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { value: formProps.values.contractValidUntil, format: t("common.date"), onChange: function (e) {
                                            formProps.setFieldValue("contractValidUntil", e);
                                        } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("exchangeRate").touched) &&
                                        formProps.errors.exchangeRate &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("exchangeRate").touched) &&
                                        formProps.errors.exchangeRate, label: t("sc.exchangeRate"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.exchangeRate, onChange: function (e) {
                                            return formProps.setFieldValue("exchangeRate", e.target.value);
                                        } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                        formProps.getFieldMeta("exchangeRate").touched) &&
                                        formProps.errors.exchangeRate &&
                                        "error", help: (formProps.submitCount ||
                                        formProps.getFieldMeta("exchangeRate").touched) &&
                                        formProps.errors.exchangeRate, label: t("sc.notices"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.notices, onChange: function (e) {
                                            return formProps.setFieldValue("notices", e.target.value);
                                        } }) }))] }))] })) })), (0, jsx_runtime_1.jsx)(htmlToImg_1.default, { tableRef: tableRef, SCId: SCId })] })));
}
exports.default = SCCreate;
var revokeSC = function (orderId, SCId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var SCNs, someCompleted;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0: return [4 /*yield*/, collectionsRef_1.SCNsRef.where("orderId", "==", orderId).get()];
            case 1:
                SCNs = (_a = (_e.sent())) === null || _a === void 0 ? void 0 : _a.docs;
                someCompleted = SCNs.some(function (x) {
                    var data = x.data();
                    return data.status === "singedAndArchived" || data.status === "completed";
                });
                if (someCompleted) {
                    throw new Error("alerts.youCannotRevokeSingedForm");
                }
                return [4 /*yield*/, collectionsRef_1.notificationsRef.where("docId", "==", SCId).get()];
            case 2:
                (_c = (_b = (_e.sent())) === null || _b === void 0 ? void 0 : _b.docs) === null || _c === void 0 ? void 0 : _c.map(function (x) {
                    return transaction.delete(x.ref);
                });
                return [4 /*yield*/, collectionsRef_1.approvalsRef.where("formId", "==", SCId).get()];
            case 3:
                (_d = (_e.sent())) === null || _d === void 0 ? void 0 : _d.docs.map(function (x) {
                    return transaction.delete(x.ref);
                }),
                    transaction.update(collectionsRef_1.SCRef.doc(SCId), {
                        status: "draft",
                        requestedBy: firebase_1.default.firestore.FieldValue.delete(),
                        requestedAt: firebase_1.default.firestore.FieldValue.delete(),
                    }),
                    transaction.update(collectionsRef_1.ordersRef.doc(orderId), { status: "preparingSC" });
                return [2 /*return*/];
        }
    });
}); };
exports.revokeSC = revokeSC;
var deleteSC = function (SCId, transaction) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, transaction.get(collectionsRef_1.SCRef.doc(SCId))];
            case 1:
                data = (_a.sent()).data();
                if (!(data.status === "singedAndArchived" || data.status === "completed")) return [3 /*break*/, 2];
                throw new Error("alerts.youCannotDeleteSingedForm");
            case 2:
                transaction.delete(collectionsRef_1.SCRef.doc(SCId));
                return [4 /*yield*/, collectionsRef_1.SCItemsRef.where("SCId", "==", SCId).get()];
            case 3:
                (_a.sent()).docs.map(function (x) {
                    return transaction.delete(x.ref);
                });
                return [4 /*yield*/, collectionsRef_1.notificationsRef.where("docId", "==", SCId).get()];
            case 4:
                (_a.sent()).docs.map(function (x) {
                    return transaction.delete(x.ref);
                });
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}); };
exports.deleteSC = deleteSC;
